export default __webpack_public_path__ + "pgnv-assets/6a02a1c49545607ba85edd24b18ce089.png";